import { Flex, FlexProps } from '@chakra-ui/react';

export const FlexCallout = (props: FlexProps) => {
  return <Flex bg="brand.superLight" p="16px" borderRadius="4px" {...props} />;
};
